import React from 'react';
import { Link } from 'react-router-dom';
import { Dropdown, DropdownMenuItem } from 'rhinostyle';

const HelpDropdown = (props) => (
  <Dropdown
    title="Help"
    icon="question-circle"
    hideCaret
    wide
    lockLabel
    {...props}
  >
    <DropdownMenuItem
      label="Help Center"
      url="https://rhinogram.my.site.com/academy/s"
      blankWindow
    />
    <DropdownMenuItem
      label="Submit a Ticket"
      url="https://www.rhinogram.com/submit-a-ticket"
      blankWindow
    />
    <Link to="/diagnostics">
      <DropdownMenuItem
        label="System Details"
      />
    </Link>
  </Dropdown>
);

export default HelpDropdown;
